/** Card component: cream surface, charcoal border, hard "stamp" shadow. */
import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/**
 * Render a card surface per `docs/DESIGN.md` (hairline charcoal border, 10px
 * radius, flat — no shadow).
 *
 * @param props - Div properties; unknown props are spread on the container.
 * @returns The card element.
 */
export function Card({ className, children, ...rest }: CardProps) {
  const classes = ['ui-card', className].filter(Boolean).join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
